<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">
          {{ $t("t_manager_socket_group_list") }}
        </h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="rulesForm"
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="$t('t_socket_group_list_name')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          size="large"
                          :placeholder="
                            $t('t_socket_group_list_name_placeholder')
                          "
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t_socket_group_list_name')"
              min-width="200"
              align="left"
              :sortable="true"
            >
              <template #default="scope">
                <el-tooltip
                  class="item"
                  popper-class="custom-tooltip"
                  effect="light"
                  :content="scope.row.name"
                  placement="top-start"
                >
                  <span class="truncate-text">{{ scope.row.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t_number_of_sockets')"
              width="170"
              align="center"
              :sortable="true"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ scope.row.socket_ids ? scope.row.socket_ids.length : 0 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t_request_success_fail_count')"
              width="250"
              align="center"
              :sortable="true"
              sort-by="countAPI"
            >
              <template #default="scope">
                <template v-if="scope.row.countAPI === '- / -'">
                  <span class="text-muted">- / -</span>
                </template>
                <template v-else>
                  <span class="text-success fw-semibold">{{
                    scope.row.countAPI.split(" / ")[0]
                  }}</span>
                  <span class="text-muted"> / </span>
                  <span class="text-danger fw-semibold">{{
                    scope.row.countAPI.split(" / ")[1]
                  }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="140px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>
      <FormNhomSocket
        v-model="showDialogAddSocketGroup"
        :typeForm="typeForm"
        :idGroup="idSocketGroup"
        :dataForm="dataFormSocketGroup"
        @success="fetchDataSocketGroup"
      />
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import FormNhomSocket from "./form-nhom-socket.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import Swal from "sweetalert2";
import toastr from "toastr";
import DataForm from "./dataQuanLySocketGroup";
import mushroom from "cem-primary-api";
// import { Project } from "mushroomjs";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const showDialogAddSocketGroup = ref(false);
const dataFormSocketGroup = reactive({
  name: "",
  socket_ids: [],
});
const typeForm = ref("createForm");
const idSocketGroup = ref("");

const fn_handle = (type, row) => {
  if (type === "create") {
    typeForm.value = "createForm";
    dataFormSocketGroup.name = "";
    dataFormSocketGroup.socket_ids = [];
    showDialogAddSocketGroup.value = true;
  }
  if (type === "update") {
    typeForm.value = "updateForm";
    idSocketGroup.value = row.id;
    dataFormSocketGroup.name = row.name;
    dataFormSocketGroup.socket_ids = row.socket_ids || [];
    showDialogAddSocketGroup.value = true;
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_noti_socket_group_list"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.api_socket_group.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            toastr.success(t("t_deleted_socket_group_list"));
            fetchDataSocketGroup();
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          if (e.code === 404) {
            toastr.warning(t("t_being_assigned_socket_group_list"));
          } else MethodService.showError(e.code);
        }
      }
    });
  }
};

const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(MethodService.routerReplace("SocketGroupList", tableRules))
    .catch(() => {});
};

const fn_TimKiem = () => {
  tableRules.dataSearch.value.name = tableRules.dataSearch.value.name?.trim();
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch)
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  fetchDataSocketGroup();
};

const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};

const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};

const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};

const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};

const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fetchDataSocketGroup();
};

const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fetchDataSocketGroup();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const changeData = async (data) => {
  if (!data || data.length === 0) return data;
  const socketGroupIds = data.map((item) => item.id);
  try {
    const response =
      await mushroom.api_request_log.views.stats_count_request_group_by_socket_groupAsync(
        {
          socket_group_ids: socketGroupIds,
          // from: value_of_from
        }
      );

    if (response.result && response.result.length > 0) {
      const statsMap = new Map(
        response.result.map((i) => [i.socket_group_id, i])
      );

      data.forEach((item) => {
        const stats = statsMap.get(item.id);
        if (stats) {
          item.countAPI = `${stats.count || '-'} / ${stats.failCount || '-'}`;
        } else {
          item.countAPI = "- / -";
        }
      });
    } else {
      data.forEach((item) => {
        item.countAPI = "- / -";
      });
    }
  } catch (e) {
    console.error("Lỗi khi lấy thống kê: ", e);
    data.forEach((item) => {
      item.countAPI = "- / -";
    });
  }
  return data;
};

const fetchDataSocketGroup = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  router
    .replace(MethodService.routerReplace("SocketGroupList", tableRules))
    .catch(() => {});
  try {
    const response = await mushroom.api_socket_group.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = await changeData(response.result);
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fn_hashUrl();
  await fetchDataSocketGroup();
});
</script>

<style scoped>
.truncate-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.custom-tooltip {
  max-width: 300px !important;
  word-break: break-all !important;
  white-space: normal !important;
}
</style>
